<script lang="ts">
	let { white = false, small = false } = $props();
	let color = $derived(white ? 'var(--static-white)' : 'var(--primary-color)');
</script>

<div class="logo" style="--theme-color: {color}">
	{#if small}
		<div class="smallLogo">
			<svg
				width="33"
				height="24"
				viewBox="0 0 33 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M2.48125 1.39744C5.00806 -0.722809 8.77525 -0.393225 10.8955 2.13359L16.3555 8.64058L21.8155 2.13359C23.9358 -0.393225 27.703 -0.722809 30.2298 1.39744C32.7566 3.51769 33.0862 7.28488 30.9659 9.8117L20.9866 21.7045C19.7931 23.1269 18.0777 23.8531 16.3555 23.8379C14.6333 23.8531 12.9179 23.1269 11.7244 21.7045L1.74509 9.8117C-0.375153 7.28488 -0.0455673 3.51769 2.48125 1.39744Z"
					fill="#511F3A"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M2.48125 1.39744C5.00806 -0.722809 8.77525 -0.393225 10.8955 2.13359L16.3555 8.64058L21.8155 2.13359C23.9358 -0.393225 27.703 -0.722809 30.2298 1.39744C32.7566 3.51769 33.0862 7.28488 30.9659 9.8117L20.9866 21.7045C19.7931 23.1269 18.0777 23.8531 16.3555 23.8379C14.6333 23.8531 12.9179 23.1269 11.7244 21.7045L1.74509 9.8117C-0.375153 7.28488 -0.0455673 3.51769 2.48125 1.39744Z"
					fill="#FDFCF6"
				/>
			</svg>
		</div>
	{:else}
		<svg
			width="111"
			height="24"
			viewBox="0 0 111 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M45.4829 1.39744C48.0097 -0.722809 51.7769 -0.393225 53.8972 2.13359L59.3572 8.64058L64.8172 2.13359C66.9374 -0.393225 70.7046 -0.722809 73.2314 1.39744C75.7583 3.51769 76.0879 7.28488 73.9676 9.8117L63.9883 21.7045C62.7948 23.1269 61.0794 23.8531 59.3572 23.8379C57.6349 23.8531 55.9196 23.1269 54.7261 21.7045L44.7468 9.8117C42.6265 7.28488 42.9561 3.51769 45.4829 1.39744ZM11.945 6.04695V0.0744415H0V23.9645H5.97251C9.27103 23.9645 11.945 21.2905 11.945 17.992L11.945 6.04695ZM11.945 6.04695C11.945 2.74842 14.619 0.0744415 17.9175 0.0744415C21.216 0.0744415 23.89 2.74842 23.89 6.04695C23.89 9.34547 21.216 12.0195 17.9175 12.0195C14.619 12.0195 11.945 9.34547 11.945 6.04695ZM39.5394 6.08183C39.5394 2.78331 36.8654 0.109325 33.5669 0.109325C30.2684 0.109324 27.5944 2.78331 27.5944 6.08183V23.9993L39.5394 23.9993V6.08183ZM79.5832 12.0184C76.3671 12.0184 73.76 14.6255 73.76 17.8416V18.1402C73.76 21.3563 76.3671 23.9634 79.5832 23.9634C82.7992 23.9634 85.4064 21.3563 85.4064 18.1402V17.8416C85.4064 14.6255 82.7992 12.0184 79.5832 12.0184ZM83.6578 1.66618C86.1847 -0.454091 89.952 -0.124554 92.0721 2.40224L110.165 23.9648H97.3572C95.5918 23.9648 93.9168 23.1837 92.782 21.8313L82.9217 10.0803C80.8016 7.55353 81.1311 3.7863 83.6578 1.66618Z"
				fill="#511F3A"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M45.4829 1.39744C48.0097 -0.722809 51.7769 -0.393225 53.8972 2.13359L59.3572 8.64058L64.8172 2.13359C66.9374 -0.393225 70.7046 -0.722809 73.2314 1.39744C75.7583 3.51769 76.0879 7.28488 73.9676 9.8117L63.9883 21.7045C62.7948 23.1269 61.0794 23.8531 59.3572 23.8379C57.6349 23.8531 55.9196 23.1269 54.7261 21.7045L44.7468 9.8117C42.6265 7.28488 42.9561 3.51769 45.4829 1.39744ZM11.945 6.04695V0.0744415H0V23.9645H5.97251C9.27103 23.9645 11.945 21.2905 11.945 17.992L11.945 6.04695ZM11.945 6.04695C11.945 2.74842 14.619 0.0744415 17.9175 0.0744415C21.216 0.0744415 23.89 2.74842 23.89 6.04695C23.89 9.34547 21.216 12.0195 17.9175 12.0195C14.619 12.0195 11.945 9.34547 11.945 6.04695ZM39.5394 6.08183C39.5394 2.78331 36.8654 0.109325 33.5669 0.109325C30.2684 0.109324 27.5944 2.78331 27.5944 6.08183V23.9993L39.5394 23.9993V6.08183ZM79.5832 12.0184C76.3671 12.0184 73.76 14.6255 73.76 17.8416V18.1402C73.76 21.3563 76.3671 23.9634 79.5832 23.9634C82.7992 23.9634 85.4064 21.3563 85.4064 18.1402V17.8416C85.4064 14.6255 82.7992 12.0184 79.5832 12.0184ZM83.6578 1.66618C86.1847 -0.454091 89.952 -0.124554 92.0721 2.40224L110.165 23.9648H97.3572C95.5918 23.9648 93.9168 23.1837 92.782 21.8313L82.9217 10.0803C80.8016 7.55353 81.1311 3.7863 83.6578 1.66618Z"
				fill="url(#paint0_radial_580_2092)"
				fill-opacity="0.2"
			/>
			<defs>
				<radialGradient
					id="paint0_radial_580_2092"
					cx="0"
					cy="0"
					r="1"
					gradientUnits="userSpaceOnUse"
					gradientTransform="translate(60.0235 16.8192) rotate(-25.8205) scale(30.8523 30.8518)"
				>
					<stop offset="0.312272" stop-color="#DB2222" />
					<stop offset="1" stop-opacity="0" />
				</radialGradient>
			</defs>
		</svg>
	{/if}
</div>

<style>
	.logo {
		height: 25px;
	}
	.logo path {
		/*target the image with css*/
		fill: var(--theme-color);
	}

	@media (max-width: 768px) {
		.logo svg {
			width: 90px;
		}
	}

	.smallLogo {
		animation: slideIn 0.5s cubic-bezier(0.075, 0.82, 0.165, 1) forwards;
		transform: translateX(0%) scaleX(1) rotateY(0deg);
		will-change: transform;
		image-rendering: optimizeSpeed;
		position: relative;
	}

	:global(.smallLogo > div) {
		will-change: transform;
	}

	@keyframes slideIn {
		from {
			opacity: 0;
			transform: scaleX(0.5) rotateY(400deg);
			right: -100%;
		}
		to {
			opacity: 1;
			transform: scaleX(1) rotateY(0deg);
			right: 20%;
		}
	}
</style>
